import {
    FormalOffers,
    NormalisedRepaymentSchedule,
    DrawdownRepaymentSchedule,
    FormalOffer
} from './MyOffers.types';
import { getMonthsfromDays } from '../multiLoanDashboard/accountsSelector';

export const isOfferTimedOut = (formal_offers: FormalOffers): boolean => {
    const formalOffer = formal_offers[0];
    return formalOffer.is_timed_out!;
};

export const getMinAvailableCash = (formal_offers: FormalOffers) => {
    //Available cash amount can vary for offers - currently only in DE
    const availableCash = formal_offers.map(
        (offer) => offer.available_cash || 0
    );
    return Math.floor(Math.min(...availableCash));
};

export const getTimeOutDate = (formalOffers: FormalOffers): string => {
    //Currently we assume all timeout dates are the same
    const formalOffer = formalOffers[0];

    const formalOfferTimeOut = formalOffer.timeout!;

    return new Date(formalOfferTimeOut).toISOString();
};

export const normaliseRepaymentSchedule = ({
    formalOffer,
    repaymentSchedule
}: {
    formalOffer: FormalOffer;
    repaymentSchedule: DrawdownRepaymentSchedule;
}): NormalisedRepaymentSchedule => {
    const {
        duration,
        offer_id,
        withdrawal_fee_percentage,
        interest_rates,
        personal_guarantee_proportion
    } = formalOffer;
    const { summary, schedule } = repaymentSchedule;
    return {
        offerId: offer_id!,
        duration: getLoanDurationInMonths(duration!),
        monthlyRepayments:
            (summary.is_equal_repayment
                ? summary.simplified_schedule?.equal_repayments?.amount
                : schedule[3]?.total) || 0,
        interestRate: interest_rates![0].rate!,
        repayments: schedule,
        totalPrincipal: summary.total_credit_amount,
        totalRepayment: summary.total_payable,
        totalInterest: summary.total_interest,
        totalFees: summary.total_fees,
        drawdownFee: withdrawal_fee_percentage!,
        hasFees: summary.total_fees! > 0,
        personalGuaranteeRequired:
            personal_guarantee_proportion === undefined
                ? undefined
                : personal_guarantee_proportion > 0
    };
};

export const getLoanDurationInMonths = (duration: {
    amount: number;
    unit: 'days' | 'months' | 'years';
}): number => {
    const { amount, unit } = duration!;
    if (unit === 'days') {
        return getMonthsfromDays(amount);
    }
    if (unit === 'years') {
        return amount * 12;
    }
    return amount;
};

export const getNonInterestOnlyPaymentAmount = (
    drawdownSchedule: DrawdownRepaymentSchedule['schedule']
): number => {
    const scheduleItem = drawdownSchedule.find(
        (schedule: DrawdownRepaymentSchedule['schedule'][0]) =>
            //interest-only schedule items have a principal of 0
            schedule.principal > 0
    );
    return scheduleItem?.total || 0;
};

export const getInterestOnlySchedule = (
    drawdownSchedule: DrawdownRepaymentSchedule['schedule'] | null
): DrawdownRepaymentSchedule['schedule'] | null => {
    if (!drawdownSchedule) return null;
    const interestOnlySchedules = drawdownSchedule.filter(
        //interest-only schedule items have a principal of 0
        (schedule) => schedule.principal === 0
    );
    return interestOnlySchedules;
};
